import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LoadingSpinner from "../LoadingSpinner";

const MainLayout = () => {
  return (
    <div className="flex flex-col min-h-screen text-gray-800 dark:text-gray-200">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8">
        <Suspense
          fallback={
            <div className="flex justify-center items-center h-[60vh]">
              <LoadingSpinner size="large" text="Chargement de la page..." />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
